// extracted by mini-css-extract-plugin
module.exports = {"socialIcon":"SocialIcon_socialIcon__XbBBv","socialIconOutline":"SocialIcon_socialIconOutline__uhTDq","socialIconOutlineInverse":"SocialIcon_socialIconOutlineInverse__EeGno"};